// Schema-driven form definitions per module.
// Adding a new module = add its schema here; PraticaDetail renders it automatically.
// Field types: text | select | date | number | textarea
// showIf: (form) => bool — conditional visibility for sections and fields.

export const NATURE_GIURIDICHE = [
    "SS", "SNC", "SAS", "SRL", "SRLS", "SPA", "SAPA", "COOP",
    "ASSOCIAZIONE", "FONDAZIONE", "ENTE_NON_COMMERCIALE", "CONSORZIO",
    "CONDOMINIO", "TRUST", "ENTE_PUBBLICO", "ALTRO",
];

const TIPO_OPTIONS_PF = [
    { value: "1", label: "1 — Apertura" },
    { value: "2", label: "2 — Variazione" },
    { value: "3", label: "3 — Cessazione" },
];

const TIPO_OPTIONS_SOC = [
    { value: "1", label: "1 — Inizio attività" },
    { value: "2", label: "2 — Variazione" },
    { value: "3", label: "3 — Cessazione" },
];

export const FORM_SCHEMAS = {
    COMUNICA_RI: {
        sections: [
            { title: "Pratica camerale", fields: [
                { path: "adempimento", label: "Adempimento", type: "select", options: [{value:"ISCRIZIONE",label:"Iscrizione"},{value:"VARIAZIONE",label:"Variazione"},{value:"CESSAZIONE",label:"Cessazione"},{value:"DEPOSITO",label:"Deposito"}] },
                { path: "tipo_soggetto", label: "Tipo soggetto", type: "select", options: [{value:"IMPRESA_INDIVIDUALE",label:"Impresa individuale"},{value:"SOCIETA",label:"Società"},{value:"ENTE",label:"Ente"},{value:"ALTRO",label:"Altro"}] },
                { path: "pratica.camera_commercio", label: "Camera di commercio" }, { path: "pratica.data_effetto", label: "Data effetto", type: "date" },
                { path: "pratica.descrizione", label: "Descrizione adempimento", type: "textarea" },
            ]},
            { title: "Impresa", fields: [
                { path: "impresa.denominazione", label: "Denominazione" }, { path: "impresa.codice_fiscale", label: "Codice fiscale", upper: true },
                { path: "impresa.forma_giuridica", label: "Forma giuridica" }, { path: "impresa.rea", label: "REA" }, { path: "impresa.pec", label: "PEC" },
                { path: "impresa.codice_ateco", label: "Codice ATECO" }, { path: "impresa.descrizione_attivita", label: "Descrizione attività", type: "textarea" },
            ]},
            { title: "Sede", fields: [
                { path: "sede.comune", label: "Comune" }, { path: "sede.provincia", label: "Provincia", upper: true, maxLength: 2 },
                { path: "sede.cap", label: "CAP", maxLength: 5 }, { path: "sede.indirizzo", label: "Indirizzo" }, { path: "sede.civico", label: "Civico" },
            ]},
            { title: "Dichiarante", fields: [
                { path: "dichiarante.nome", label: "Nome" }, { path: "dichiarante.cognome", label: "Cognome" }, { path: "dichiarante.codice_fiscale", label: "Codice fiscale", upper: true },
                { path: "dichiarante.qualifica", label: "Qualifica" }, { path: "dichiarante.email", label: "Email" },
            ]},
        ],
    },
    AA9_12: {
        sections: [
            {
                title: "Tipo dichiarazione",
                fields: [
                    { path: "tipo_dichiarazione", label: "Tipo", type: "select", options: TIPO_OPTIONS_PF, testid: "form-tipo" },
                    { path: "partita_iva", label: "Partita IVA esistente", type: "text", maxLength: 11, testid: "form-piva", showIf: (f) => f.tipo_dichiarazione === "2" || f.tipo_dichiarazione === "3" },
                    { path: "data_variazione", label: "Data variazione", type: "date", testid: "form-data-var", showIf: (f) => f.tipo_dichiarazione === "2" },
                    { path: "data_cessazione", label: "Data cessazione", type: "date", testid: "form-data-cess", showIf: (f) => f.tipo_dichiarazione === "3" },
                ],
            },
            {
                title: "Quadro B — Dati identificativi",
                fields: [
                    { path: "quadro_b.codice_fiscale", label: "Codice fiscale", type: "text", maxLength: 16, upper: true, testid: "form-cf" },
                    { path: "quadro_b.cognome", label: "Cognome", type: "text" },
                    { path: "quadro_b.nome", label: "Nome", type: "text" },
                    { path: "quadro_b.sesso", label: "Sesso", type: "select", options: [{ value: "M", label: "M" }, { value: "F", label: "F" }] },
                    { path: "quadro_b.data_nascita", label: "Data di nascita", type: "date" },
                    { path: "quadro_b.comune_nascita", label: "Comune nascita", type: "text" },
                    { path: "quadro_b.provincia_nascita", label: "Provincia nascita", type: "text", maxLength: 2, upper: true },
                    { path: "quadro_b.indirizzo_residenza", label: "Indirizzo residenza", type: "text" },
                    { path: "quadro_b.comune_residenza", label: "Comune residenza", type: "text" },
                    { path: "quadro_b.provincia_residenza", label: "Provincia", type: "text", maxLength: 2, upper: true },
                    { path: "quadro_b.cap_residenza", label: "CAP", type: "text", maxLength: 5 },
                ],
            },
            {
                title: "Quadro B — Attività prevalente e luogo di esercizio",
                showIf: (f) => f.tipo_dichiarazione === "1" || f.tipo_dichiarazione === "2",
                fields: [
                    { path: "quadro_c.codice_attivita_ateco", label: "Codice ATECO", type: "text", placeholder: "62.01.00" },
                    { path: "quadro_c.descrizione_attivita", label: "Descrizione attività", type: "text" },
                    { path: "quadro_c.data_inizio_attivita", label: "Data inizio attività", type: "date", showIf: (f) => f.tipo_dichiarazione === "1" },
                    {
                        path: "quadro_c.regime_fiscale", label: "Regime fiscale", type: "select",
                        options: [
                            { value: "ORDINARIO", label: "Ordinario" },
                            { value: "FORFETTARIO", label: "Forfettario" },
                            { value: "MINIMI", label: "Minimi" },
                        ],
                    },
                    { path: "quadro_c.volume_affari_presunto", label: "Volume affari presunto (€)", type: "number" },
                ],
            },
            {
                title: "Quadro B — Luogo di esercizio",
                showIf: (f) => f.tipo_dichiarazione === "1" || f.tipo_dichiarazione === "2",
                fields: [
                    { path: "quadro_d.comune", label: "Comune", type: "text" },
                    { path: "quadro_d.provincia", label: "Provincia", type: "text", maxLength: 2, upper: true },
                    { path: "quadro_d.cap", label: "CAP", type: "text", maxLength: 5 },
                    { path: "quadro_d.indirizzo", label: "Indirizzo", type: "text" },
                ],
            },
            {
                title: "Impegno alla presentazione telematica",
                showIf: (f) => f.tipo_dichiarazione === "2",
                fields: [
                    { path: "quadro_telematico.codice_fiscale_intermediario", label: "Codice fiscale intermediario", type: "text", maxLength: 16, upper: true },
                    {
                        path: "quadro_telematico.tipo_impegno", label: "Tipo impegno", type: "select",
                        options: [
                            { value: "1", label: "1 — Dichiarazione predisposta dal contribuente" },
                            { value: "2", label: "2 — Dichiarazione predisposta dal soggetto che la trasmette" },
                        ],
                    },
                    { path: "quadro_telematico.data_impegno", label: "Data impegno", type: "date" },
                    { path: "quadro_telematico.numero_iscrizione_caf", label: "N. iscrizione albo CAF", type: "text", maxLength: 5 },
                ],
            },
        ],
    },

    AA7_10: {
        sections: [
            {
                title: "Tipo dichiarazione",
                fields: [
                    { path: "tipo_dichiarazione", label: "Tipo", type: "select", options: TIPO_OPTIONS_SOC, testid: "form-tipo" },
                    { path: "partita_iva", label: "Partita IVA esistente", type: "text", maxLength: 11, testid: "form-piva", showIf: (f) => f.tipo_dichiarazione === "2" || f.tipo_dichiarazione === "3" },
                    { path: "data_variazione", label: "Data variazione", type: "date", showIf: (f) => f.tipo_dichiarazione === "2" },
                    { path: "data_cessazione", label: "Data cessazione", type: "date", showIf: (f) => f.tipo_dichiarazione === "3" },
                ],
            },
            {
                title: "Quadro B — Dati del soggetto",
                fields: [
                    { path: "quadro_b.denominazione", label: "Denominazione / Ragione sociale", type: "text", testid: "form-denominazione" },
                    { path: "quadro_b.natura_giuridica", label: "Natura giuridica", type: "select", options: NATURE_GIURIDICHE.map((n) => ({ value: n, label: n.replace(/_/g, " ") })), testid: "form-natura" },
                    { path: "quadro_b.codice_fiscale", label: "Codice fiscale (11 cifre)", type: "text", maxLength: 16, upper: true, testid: "form-cf-soggetto" },
                    { path: "quadro_b.pec", label: "PEC", type: "text" },
                    { path: "quadro_b.telefono", label: "Telefono", type: "text", maxLength: 12 },
                    { path: "quadro_b.comune_sede", label: "Comune sede legale", type: "text" },
                    { path: "quadro_b.provincia_sede", label: "Provincia sede", type: "text", maxLength: 2, upper: true },
                    { path: "quadro_b.cap_sede", label: "CAP sede", type: "text", maxLength: 5 },
                    { path: "quadro_b.indirizzo_sede", label: "Indirizzo sede", type: "text" },
                    { path: "quadro_b.civico_sede", label: "Civico", type: "text", maxLength: 6 },
                ],
            },
            {
                title: "Quadro C — Rappresentante legale",
                fields: [
                    { path: "quadro_c.codice_fiscale", label: "Codice fiscale", type: "text", maxLength: 16, upper: true, testid: "form-cf-rappr" },
                    { path: "quadro_c.cognome", label: "Cognome", type: "text" },
                    { path: "quadro_c.nome", label: "Nome", type: "text" },
                    {
                        path: "quadro_c.codice_carica", label: "Codice carica", type: "select",
                        options: [
                            { value: "1", label: "1 — Rappresentante legale" },
                            { value: "2", label: "2 — Socio amministratore" },
                            { value: "3", label: "3 — Curatore fallimentare" },
                            { value: "5", label: "5 — Commissario liquidatore" },
                            { value: "6", label: "6 — Rappresentante fiscale" },
                        ],
                    },
                    { path: "quadro_c.data_nascita", label: "Data di nascita", type: "date" },
                    { path: "quadro_c.comune_nascita", label: "Comune nascita", type: "text" },
                    { path: "quadro_c.provincia_nascita", label: "Provincia nascita", type: "text", maxLength: 2, upper: true },
                ],
            },
            {
                title: "Quadro D — Attività e luogo di esercizio",
                showIf: (f) => f.tipo_dichiarazione === "1" || f.tipo_dichiarazione === "2",
                fields: [
                    { path: "quadro_d.codice_attivita_ateco", label: "Codice ATECO", type: "text", placeholder: "62.01.00" },
                    { path: "quadro_d.descrizione_attivita", label: "Descrizione attività", type: "text" },
                    { path: "quadro_d.data_inizio_attivita", label: "Data inizio attività", type: "date" },
                    { path: "quadro_d.volume_affari_presunto", label: "Volume affari presunto (€)", type: "number" },
                    { path: "quadro_d.comune", label: "Comune luogo esercizio", type: "text" },
                    { path: "quadro_d.provincia", label: "Provincia", type: "text", maxLength: 2, upper: true },
                    { path: "quadro_d.cap", label: "CAP", type: "text", maxLength: 5 },
                    { path: "quadro_d.indirizzo", label: "Indirizzo", type: "text" },
                ],
            },
        ],
    },
};
